"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _ReactStaticPage = require("../../../react-static/page/ReactStaticPage");

var _mobxReact = require("mobx-react");

var _Home = require("./Home");

var _reactStatic = require("react-static");

var _HomepageLinks = require("../homepage/HomepageLinks");

var _class;

var HomePage = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(HomePage, _Component);

  function HomePage(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = HomePage.prototype;

  _proto.render = function render() {
    var title = this.props.title;
    return _react.default.createElement(_ReactStaticPage.ReactStaticPage, (0, _extends2.default)({
      title: title,
      seoMetadata: (0, _Home.HomeSeoMetadata)()
    }, this.props), _react.default.createElement("p", null, "The Travel Webway site contains guides, tips and tools for you to make the most of your travel experience using the power of the web."), _react.default.createElement("p", null, "If you are on a business trip, backpacking, camping, hiking, road tripping, off-roading, touring, ocean cruising, sporting, picnicking, or going to a special event, we want to help you!"), _react.default.createElement(_HomepageLinks.HomepageLinks, null));
  };

  return HomePage;
}(_react.Component)) || _class;

var _default = (0, _reactStatic.withRouteData)(HomePage);

exports.default = _default;